<template>
  <div>
    <!--body section start -->
    <div id="body-section" class="doner-home">
      <div class="container">
        <div class="row doner-profile">
          <div class="col-md-3">
            <div class="profile-left">
              <router-link :to="{ name: 'Donor' }" class="yellow-btn">
                Home
              </router-link>
              <router-link :to="{ name: 'DonorProfile' }" class="yellow-btn">
                Doner profile
              </router-link>
              <router-link
                :to="{ name: 'DonorScholarship' }"
                class="yellow-btn"
              >
                Students
              </router-link>
              <router-link
                :to="{ name: 'SpecialMealReport' }"
                class="green-btn"
              >
                Special Meals
              </router-link>
            </div>
          </div>
          <div class="col-md-9">
            <div class="title-bar">
              <div class="row">
                <div class="title">
                  <router-link :to="{ name: 'DonationClarification' }">
                    <img src="/assets/images/icon/plus.webp" alt="" /> New
                    donation Clerification
                  </router-link>
                </div>
              </div>
            </div>
            <div class="profile-right">
              <div class="row" style="display: none;">
                <div class="filter-area ">
                  <div>
                    <form method="POST" action="">
                      <label for="Entries" class="top_label">Show</label>
                      <select name="entries" id="entries">
                        <option value="show-10">10</option>
                        <option value="show-10">20</option>
                        <option value="show-10">30</option>
                        <option value="show-10">50</option>
                      </select>
                      <label for="Entries">Entries</label>
                    </form>
                  </div>
                  <div class="search">
                    <form class="search" action="">
                      <input type="text" placeholder="SEARCH" name="search" />
                      <button type="submit">
                        <img
                          src="/assets/images/icon/search-yellow.webp"
                          alt=""
                        />
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row table-section">
                <div style="overflow-x:auto; width: 100%;">
                  <table class="transaction table">
                    <tr>
                      <th>NO</th>
                      <th>EVENT DATE</th>
                      <th>BRANCH</th>
                      <th>FOOD MENU</th>
                      <th>QUANTITY</th>
                      <th>COST</th>
                      <th>STATUS</th>
                      <th>FEEDBACK</th>
                    </tr>

                    <tr
                      v-for="(inbox_data, index) in loadedPaginatedData"
                      :key="inbox_data.id"
                    >
                      <td v-if="current_page == 1">
                        {{ parseInt(index) + 1 }}
                      </td>
                      <td v-else>
                        {{
                          parseInt(perPageData) * (parseInt(current_page) - 1) +
                            parseInt(index) +
                            1
                        }}
                      </td>
                      <td>{{ inbox_data.event_date }}</td>
                      <td>{{ inbox_data.branch_name }}</td>
                      <td>{{ inbox_data.food_item_name }}</td>
                      <td>{{ inbox_data.no_unit }}</td>
                      <td style="text-align:left">
                        &nbsp;
                        {{ inbox_data.unit_price }}
                        {{ inbox_data.currency_name }}
                      </td>
                      <td>
                        <b>
                          <span
                            v-if="inbox_data.status == 0"
                            style="color: #faa61b;"
                            >Pending</span
                          >
                          <span v-if="inbox_data.status == 1"
                            >Branch Received</span
                          >
                          <span v-if="inbox_data.status == 2"
                            >Feedback | Contact With Donor</span
                          >
                          <span
                            v-if="inbox_data.status == 4"
                            style="color: #1aad4f;"
                            >Closed & Feedback</span
                          >
                        </b>
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'DonorScholarshipFeedBack',
                            params: { id: inbox_data.id },
                          }"
                          v-if="inbox_data.status == 4 && inbox_data.images"
                        >
                          <i class="fa fa-image" style="color: #000"></i>
                        </router-link>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="row">
                <!-- Pagination Start  -->

                <div v-if="totalPage > 1">
                  <div class="page-list">
                    <ul>
                      <li class="page-no">
                        <a href="javascript:;" @click="getData(1)">
                          <font-awesome-icon icon="angle-double-left" />
                        </a>
                      </li>

                      <li class="page-no" v-if="prev_page_url">
                        <a href="javascript:;" @click="getData(prevPage)">
                          <font-awesome-icon icon="angle-left" />
                        </a>
                      </li>
                      <li class="page-no" v-else>
                        <a href="javascript:;" style="cursor: not-allowed;">
                          <font-awesome-icon icon="angle-left" />
                        </a>
                      </li>

                      <li
                        v-for="pageNum in totalPage"
                        :key="pageNum"
                        :class="
                          pageNum > displayStartPageNumber &&
                          pageNum < displayEndPageNumber
                            ? 'page-no'
                            : 'page-no hidePaginationNumber'
                        "
                      >
                        <a
                          href="javascript:;"
                          @click="getData(pageNum)"
                          :class="current_page == pageNum ? 'active-page' : ''"
                        >
                          {{ pageNum }}
                        </a>
                      </li>

                      <li class="page-no" v-if="next_page_url">
                        <a href="javascript:;" @click="getData(nextPage)">
                          <font-awesome-icon icon="angle-right" />
                        </a>
                      </li>
                      <li class="page-no" v-else>
                        <a href="javascript:;" style="cursor: not-allowed;">
                          <font-awesome-icon icon="angle-right" />
                        </a>
                      </li>

                      <li class="page-no">
                        <a href="javascript:;" @click="getData(totalPage)">
                          <font-awesome-icon icon="angle-double-right" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- Pagination End -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--body section start -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
const apiResourceUrl = process.env.VUE_APP_APIURL;
export default {
  name: "DonorSpecialMeal",
  data() {
    return {
      specialMealArr: {},
      adminPanelUrl: process.env.VUE_APP_ADMINPANELURL,
      perPageData: 10,
      paginationPageBtnLength: 5,
      current_page: null,
      prev_page_url: false,
      next_page_url: false,
      totalPage: null,
      prevPage: null,
      nextPage: null,
      loadedPaginatedData: {},
      displayStartPageNumber: null,
      displayEndPageNumber: null,
    };
  },

  methods: {
    initPagination() {
      if (this.specialMealArr.length > this.perPageData) {
        //Count Total page Start
        let totPage =
          parseInt(this.specialMealArr.length) / parseInt(this.perPageData);
        if (
          parseInt(this.specialMealArr.length) % parseInt(this.perPageData) !=
          0
        ) {
          totPage = parseInt(totPage) + 1;
        }
        this.totalPage = totPage;
        //Count Total page End

        this.current_page = 1;
        this.displayStartPageNumber = 0;
        this.displayEndPageNumber = this.paginationPageBtnLength - 1;
        this.getData(1);
      } else {
        this.loadedPaginatedData = this.specialMealArr;
      }
    },

    paginationClientMenuOrganise() {
      this.prevPage = null;
      this.nextPage = null;

      if (this.totalPage == 1) {
        this.next_page_url = false;
        this.prev_page_url = false;
      } else {
        this.nextPage = this.current_page + 1;
        this.prevPage = this.current_page - 1;
      }

      if (this.current_page == this.totalPage) {
        this.next_page_url = false;
      }

      if (this.current_page == 1) {
        this.prev_page_url = false;
      }

      let interval = parseInt(this.paginationPageBtnLength / 2);
      if (this.totalPage <= this.paginationPageBtnLength) {
        this.displayStartPageNumber = 0;
        this.displayEndPageNumber = this.paginationPageBtnLength + 1;
      } else {
        if (this.current_page - interval <= 1) {
          this.displayStartPageNumber = 0;
          this.displayEndPageNumber = this.paginationPageBtnLength + 1;
        } else if (this.current_page + interval >= this.totalPage) {
          this.displayStartPageNumber =
            this.totalPage - this.paginationPageBtnLength;
          this.displayEndPageNumber = this.totalPage + 1;
        } else {
          this.displayStartPageNumber = this.current_page - interval - 1;
          this.displayEndPageNumber = this.current_page + interval + 1;
        }
      }
    },

    getData(pageNum) {
      let toNumber = pageNum * this.perPageData;
      let fromNumber = toNumber - this.perPageData;
      //console.log(this.specialMealArr.slice(fromNumber, toNumber));
      this.loadedPaginatedData = this.specialMealArr.slice(
        fromNumber,
        toNumber
      );
      this.current_page = pageNum;

      this.next_page_url = false;
      this.prev_page_url = false;
      if (pageNum < this.totalPage) {
        this.next_page_url = true;
      }

      if (pageNum > 1) {
        this.prev_page_url = true;
      }
      this.paginationClientMenuOrganise();
    },
  },

  async created() {
    await axios
      .get(apiResourceUrl + "/special-meal-report")
      .then((response) => {
        this.specialMealArr = response.data.specialMealArr;
        //console.log(response.data.specialMealArr);
        this.initPagination();
      });
  },

  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
